import { render, staticRenderFns } from "./accessPage.vue?vue&type=template&id=fc7cf9c4&scoped=true&"
import script from "./accessPage.vue?vue&type=script&lang=js&"
export * from "./accessPage.vue?vue&type=script&lang=js&"
import style0 from "./accessPage.vue?vue&type=style&index=0&id=fc7cf9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7cf9c4",
  null
  
)

export default component.exports